import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDepositSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={34} height={34} fill='none' {...props}>
    <rect width={34} height={34} fill='#26C6DA' rx={8} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='m14.99 16.76 1.92 1.92 1.92-1.92M16.91 11v7.628'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='M23 17.135c0 3.315-2.25 6-6 6s-6-2.685-6-6'
    />
  </svg>
);
export default SvgDepositSmall;
